(function () {
  'use strict';

  /* iOS Safari only triggers :active/:hover CSS states on tap if a touchstart
     listener is registered somewhere on the page — without this, the new green-lining
     tap animation on product cards (and existing nav/drawer tap states) silently never
     fire on iPhone. Registering it once here unlocks :active site-wide. */
  document.addEventListener('touchstart', function () {}, { passive: true });

  var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* Scroll progress bar — present on every template */
  var bar = document.createElement('div');
  bar.className = 'ks-scroll-progress';
  bar.setAttribute('aria-hidden', 'true');
  bar.textContent = '​';
  document.body.appendChild(bar);
  function updateProgress() {
    var doc = document.documentElement;
    var max = doc.scrollHeight - doc.clientHeight;
    var pct = max > 0 ? (doc.scrollTop / max) * 100 : 0;
    bar.style.width = pct + '%';
  }
  window.addEventListener('scroll', updateProgress, { passive: true });
  window.addEventListener('resize', updateProgress);
  updateProgress();

  /* Product gallery — press and hold on the boot image to auto-cycle through its photos with a sliding transition. Targets the shared gallery component so it applies to every product automatically. */
  if (!reduceMotion) {
    var gallerySliders = document.querySelectorAll(
      'main[data-template="product"] slider-component .product__media-list.slider'
    );
    gallerySliders.forEach(function (slider) {
      var slides = Array.prototype.slice.call(slider.querySelectorAll(':scope > [id^="Slide-"]'));
      if (slides.length < 2) return;

      var offset = slides[1].offsetLeft - slides[0].offsetLeft;
      var holdTimer = null;
      var advanceTimer = null;
      var startX = 0;
      var startY = 0;
      var moved = false;

      function currentIndex() {
        return Math.round(slider.scrollLeft / offset);
      }
      function advance() {
        var next = (currentIndex() + 1) % slides.length;
        slider.scrollTo({ left: next * offset, behavior: 'smooth' });
      }
      function beginCycle() {
        if (advanceTimer) return;
        advance();
        advanceTimer = setInterval(advance, 900);
      }
      function endCycle() {
        clearTimeout(holdTimer);
        clearInterval(advanceTimer);
        holdTimer = null;
        advanceTimer = null;
      }

      slider.addEventListener(
        'touchstart',
        function (e) {
          moved = false;
          var t = e.touches[0];
          startX = t.clientX;
          startY = t.clientY;
          holdTimer = setTimeout(function () {
            if (!moved) beginCycle();
          }, 180);
        },
        { passive: true }
      );

      slider.addEventListener(
        'touchmove',
        function (e) {
          var t = e.touches[0];
          if (Math.abs(t.clientX - startX) > 8 || Math.abs(t.clientY - startY) > 8) {
            moved = true;
            endCycle();
          }
        },
        { passive: true }
      );

      slider.addEventListener('touchend', endCycle);
      slider.addEventListener('touchcancel', endCycle);

      // Desktop parity: press and hold with the mouse too.
      slider.addEventListener('mousedown', function () {
        holdTimer = setTimeout(beginCycle, 180);
      });
      window.addEventListener('mouseup', endCycle);
      slider.addEventListener('mouseleave', endCycle);
    });
  }

  if (reduceMotion) return;

  /* Staggered scroll reveal — applied across every template */
  var revealSelectors = [
    'main[data-template="index"] .title',
    'main[data-template="index"] .collection-list-title',
    'main[data-template="index"] .card-wrapper',
    'main[data-template="index"] .collection-list__item',
    'main[data-template="index"] .multicolumn-card',
    'main[data-template="index"] .football-hero__spec',
    'main[data-template="index"] .image-with-text__content',
    'main[data-template="collection"] .collection-hero__title',
    'main[data-template="collection"] .card-wrapper',
    'main[data-template="product"] .related-products .card-wrapper',
    'main[data-template="page"] .page-title',
    'main[data-template="page"] .rte',
    'main[data-template="cart"] .title--primary',
    'main[data-template="cart"] .cart-item',
    'main[data-template="search"] .grid__item'
  ];
  var revealEls = Array.prototype.slice.call(
    document.querySelectorAll(revealSelectors.join(','))
  );

  revealEls.forEach(function (el, i) {
    el.classList.add('ks-reveal');
    el.style.transitionDelay = (i % 6) * 70 + 'ms';
  });

  if ('IntersectionObserver' in window && revealEls.length) {
    var io = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            entry.target.classList.add('ks-reveal--visible');
            io.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.12, rootMargin: '0px 0px -40px 0px' }
    );
    revealEls.forEach(function (el) {
      io.observe(el);
    });
  } else {
    revealEls.forEach(function (el) {
      el.classList.add('ks-reveal--visible');
    });
  }
})();
